import React from 'react';
import { Link } from 'react-router-dom';
import { ZapIcon, GitBranchIcon, ClockIcon, TargetIcon, CheckCircleIcon, ArrowRightIcon, PlayIcon, TrendingUpIcon } from 'lucide-react';
export function PlatformOrchestrationPage() {
  return <div className="w-full bg-white" data-id="element-7533">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-indigo-900 via-purple-800 to-pink-900 text-white py-24 overflow-hidden" data-id="element-7534">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-7535" />
        <div className="absolute inset-0" data-id="element-7536">
          <div className="absolute top-20 left-10 w-72 h-72 bg-indigo-500/20 rounded-full blur-3xl animate-pulse" data-id="element-7537" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-7538" />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-7539">
          <div className="max-w-4xl mx-auto text-center" data-id="element-7540">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-500/20 rounded-full border border-indigo-400/30 mb-6" data-id="element-7541">
              <GitBranchIcon className="w-4 h-4" data-id="element-7542" />
              <span className="text-sm font-medium" data-id="element-7543">
                Multi-Channel Automation
              </span>
            </div>
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-7544">
              Platform Orchestration
            </h1>
            <p className="text-xl text-indigo-100 mb-8 leading-relaxed" data-id="element-7545">
              Coordinate complex GTM motions across every channel, system, and
              team — all from one place. No more duct-taped workflows.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-7546">
              <Link to="/signup" className="px-8 py-4 bg-white text-indigo-900 rounded-lg hover:bg-indigo-50 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-7547">
                Get Started
              </Link>
              <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7548">
                Schedule Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* What Orchestration Does */}
      <section className="py-24 bg-white" data-id="element-7549">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7550">
          <div className="text-center mb-16" data-id="element-7551">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7552">
              What Orchestration does
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-7553">
              Orchestration connects your GTM systems and automates
              cross-functional workflows so plays run consistently at scale.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7554">
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-8 border-2 border-indigo-200" data-id="element-7555">
              <div className="w-16 h-16 bg-indigo-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7556">
                <GitBranchIcon className="w-8 h-8 text-white" data-id="element-7557" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7558">
                Multi-channel execution
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7559">
                Send emails, update CRM, trigger ads, assign tasks, and notify
                reps — all in one workflow.
              </p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 border-2 border-purple-200" data-id="element-7560">
              <div className="w-16 h-16 bg-purple-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7561">
                <ZapIcon className="w-8 h-8 text-white" data-id="element-7562" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7563">
                Real-time triggers
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7564">
                Launch plays automatically when accounts hit intent thresholds,
                usage spikes, or contract milestones.
              </p>
            </div>
            <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-xl p-8 border-2 border-pink-200" data-id="element-7565">
              <div className="w-16 h-16 bg-pink-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7566">
                <ClockIcon className="w-8 h-8 text-white" data-id="element-7567" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7568">
                Smart timing
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7569">
                Respect frequency caps, business hours, and account-level
                preferences. No over-messaging.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Key Features */}
      <section className="py-24 bg-gray-50" data-id="element-7570">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7571">
          <div className="text-center mb-16" data-id="element-7572">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7573">
              Orchestration features
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-7574">
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7575">
              <div className="flex items-center gap-3 mb-4" data-id="element-7576">
                <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center" data-id="element-7577">
                  <GitBranchIcon className="w-6 h-6 text-white" data-id="element-7578" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7579">
                  Visual workflow builder
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7580">
                Drag-and-drop canvas to design multi-step plays with branching
                logic, wait steps, and conditional paths.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7581">
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm" data-id="element-7582">
                  No-code
                </span>
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm" data-id="element-7583">
                  Branching logic
                </span>
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm" data-id="element-7584">
                  Wait steps
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7585">
              <div className="flex items-center gap-3 mb-4" data-id="element-7586">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center" data-id="element-7587">
                  <ZapIcon className="w-6 h-6 text-white" data-id="element-7588" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7589">
                  Native integrations
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7590">
                Pre-built connectors for Salesforce, HubSpot, Marketo, Outreach,
                Salesloft, Slack, and 50+ tools.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7591">
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-7592">
                  50+ integrations
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-7593">
                  Pre-built
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-7594">
                  Bi-directional sync
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7595">
              <div className="flex items-center gap-3 mb-4" data-id="element-7596">
                <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center" data-id="element-7597">
                  <TargetIcon className="w-6 h-6 text-white" data-id="element-7598" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7599">
                  Dynamic segmentation
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7600">
                Accounts automatically enter and exit plays based on real-time
                eligibility. No manual list management.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7601">
                <span className="px-3 py-1 bg-pink-50 text-pink-700 rounded-full text-sm" data-id="element-7602">
                  Real-time
                </span>
                <span className="px-3 py-1 bg-pink-50 text-pink-700 rounded-full text-sm" data-id="element-7603">
                  Auto-enrollment
                </span>
                <span className="px-3 py-1 bg-pink-50 text-pink-700 rounded-full text-sm" data-id="element-7604">
                  Exit rules
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7605">
              <div className="flex items-center gap-3 mb-4" data-id="element-7606">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-7607">
                  <TrendingUpIcon className="w-6 h-6 text-white" data-id="element-7608" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7609">
                  Performance tracking
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7610">
                Real-time dashboards show which steps are working, where
                accounts drop off, and what to optimize.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7611">
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-7612">
                  Live metrics
                </span>
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-7613">
                  Drop-off analysis
                </span>
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-7614">
                  A/B testing
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* How It Works */}
      <section className="py-24 bg-white" data-id="element-7615">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7616">
          <div className="text-center mb-16" data-id="element-7617">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7618">
              How Orchestration works
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-7619">
            <div className="text-center" data-id="element-7620">
              <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7621">
                <span className="text-2xl font-bold text-white" data-id="element-7622">1</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7623">
                Define trigger
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7624">
                Set conditions that start the workflow (intent spike, stage
                change, etc.)
              </p>
            </div>
            <div className="text-center" data-id="element-7625">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7626">
                <span className="text-2xl font-bold text-white" data-id="element-7627">2</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7628">
                Build workflow
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7629">
                Design multi-step sequence with actions, delays, and branches
              </p>
            </div>
            <div className="text-center" data-id="element-7630">
              <div className="w-16 h-16 bg-pink-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7631">
                <span className="text-2xl font-bold text-white" data-id="element-7632">3</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7633">
                Connect systems
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7634">
                Link to CRM, email, ads, and other tools in your stack
              </p>
            </div>
            <div className="text-center" data-id="element-7635">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7636">
                <span className="text-2xl font-bold text-white" data-id="element-7637">4</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7638">
                Launch & optimize
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7639">
                Monitor performance and adjust based on what's working
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Use Cases */}
      <section className="py-24 bg-gray-50" data-id="element-7640">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7641">
          <div className="text-center mb-16" data-id="element-7642">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7643">
              Common orchestration workflows
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-7644">
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-indigo-300 hover:shadow-lg transition-all" data-id="element-7645">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7646">
                Intent-to-meeting
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-7647">
                Detect intent surge → enrich account → send email → update CRM →
                notify SDR → book meeting
              </p>
              <div className="text-sm text-gray-600" data-id="element-7648">
                <span className="font-medium" data-id="element-7649">Result:</span> 40% faster response
                time
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-indigo-300 hover:shadow-lg transition-all" data-id="element-7650">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7651">
                Trial-to-paid
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-7652">
                Usage milestone hit → in-app message → email sequence → CSM
                outreach → upgrade offer
              </p>
              <div className="text-sm text-gray-600" data-id="element-7653">
                <span className="font-medium" data-id="element-7654">Result:</span> 25% higher
                conversion
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-indigo-300 hover:shadow-lg transition-all" data-id="element-7655">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7656">
                Renewal risk
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-7657">
                Usage drop detected → alert CS → email champion → schedule QBR →
                escalate if needed
              </p>
              <div className="text-sm text-gray-600" data-id="element-7658">
                <span className="font-medium" data-id="element-7659">Result:</span> 15% churn reduction
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-indigo-600 to-purple-700 text-white" data-id="element-7660">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7661">
          <h2 className="text-4xl font-bold mb-6" data-id="element-7662">
            Ready to automate your GTM workflows?
          </h2>
          <p className="text-xl text-indigo-100 mb-8" data-id="element-7663">
            Start orchestrating plays across every channel and system
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-7664">
            <Link to="/signup" className="px-8 py-4 bg-white text-indigo-600 rounded-lg hover:bg-indigo-50 font-medium text-lg shadow-lg" data-id="element-7665">
              Get Started
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7666">
              Talk to Sales
            </Link>
          </div>
        </div>
      </section>
    </div>;
}